module.exports = __webpack_public_path__ + "media/images/s03_01_pt-a5e3150d7ec569dae72ef44235870381.svg";